import { Component, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { AuthComponent } from './auth/auth.component';
//import { routes } from './app.routes';

import { CommonModule, HashLocationStrategy, LocationStrategy, NgIf, registerLocaleData } from '@angular/common';
import { FormsModule, Validators } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { FooterComponent } from './footer/footer.component';
import { OrganizationsListComponent } from './organizations/organizations-list/organizations-list.component';
import { CardsModule } from './cards/cards.module';
import {MatDrawer, MatSidenavModule} from '@angular/material/sidenav';
import { MenuService } from './services/menu.service';
import { MatIcon } from '@angular/material/icon';
import { SidebarMenuComponent } from "./sidebar-menu/sidebar-menu.component";
import localePl from '@angular/common/locales/pl';

//const appRoutes = routes

registerLocaleData(localePl);

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
    FooterComponent,
    RouterOutlet,
    HeaderComponent,
    FormsModule,
    CommonModule,
    CardsModule,
    MatSidenavModule,
    SidebarMenuComponent
],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        { provide: LOCALE_ID, useValue: 'pl-PL', },
    ]
})

export class AppComponent implements OnInit {

  @ViewChild('drawer') drawer !: MatDrawer

  isSidebarExpanded:boolean = true;

  title = 'rekbot_front';

  constructor(
    public authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    //console.log(this.authService.isAuthenticated)
    const token = this.authService.getToken();
    if (token) {
      this.authService.isAuthenticated = true;
    }
  }

  toggleDarkMode() {
    document.body.classList.toggle('dark-mode');
  }

  toggleSidebar() {
    this.isSidebarExpanded = !this.isSidebarExpanded
  }
}
